module.exports = __webpack_public_path__ + "img/amigololy.44ba036f.jpg";